import { defineStore } from "pinia";
import { useAudioStore } from "./AudioStore";
import { computed, ref } from "vue";

export const useChartRenderStore = defineStore('chartRender', () => {

  // --------------------------------------------------------
  // CONSTANTS 
  // --------------------------------------------------------

  const SCROLLBAR_PADDING = 2
  const SCROLLBAR_SIZE = 10
  const mouseClickEffectpixelRange = 40

  // --------------------------------------------------------
  // STATE 
  // --------------------------------------------------------

  const zoomX = ref(1)
  const zoomY = ref(0.4)

  const offlineWaveformEnabled = ref(true)

  const columnWidth = ref(30)
  const noteHeight = ref(20)
  const subdivision = ref(1)

  const hitPosY = ref(100)
  const reverseScroll = ref(true)

  const subdivisionColouringMagicNumber = ref(4321)
  const subdivisionColours = ref([])

  // --------------------------------------------------------
  // GETTERS 
  // --------------------------------------------------------

  const getSubdivisionColour = (denominator) => {
    const i = denominator
    if (!subdivisionColours.value[i])
      subdivisionColours.value[i] = `#${(Math.trunc(i * subdivisionColouringMagicNumber.value) % 4096).toString(16)}`
    return subdivisionColours.value[i]
  }

  const timeToPixel = time => time * 1000 * zoomY.value
  const pixelToTime = pixel => pixel / (1000 * zoomY.value)

  // --------------------------------------------------------
  // ACTIONS
  // --------------------------------------------------------

  const setSubdivision = value => {
    if (value <= 0 || isNaN(value)) return 1
    value = Math.trunc(value)
    subdivision.value = value
    return value
  }

  const setZoomY = (value) => {
    if (value <= 0 || isNaN(value)) return zoomY.value
    zoomY.value = value
    return value
  }
  const setZoomX = (value) => {
    if (value <= 0) return zoomX.value
    zoomX.value = value
    return value
  }

  const setHitPosY = (value) => {
    // if (value < 0 || value > stageHeight.value || isNaN(value)) return hitPosY.value
    hitPosY.value = value
    return value
  }

  const setColumnWidth = value => {
    if (value <= 0 || isNaN(value)) return null
    columnWidth.value = value
    return value
  }

  const setSubdivisionColouringMagicNumber = (value) => {
    if (value <= 0 || isNaN(value)) return null
    subdivisionColouringMagicNumber.value = value
    subdivisionColours.value = subdivisionColours.value.map((e, index) => `#${(Math.trunc(index * subdivisionColouringMagicNumber.value) % 4096).toString(16)}`)
    return value
  }

  const setReverseScroll = value => {
    reverseScroll.value = value ? true : false
  }

  const setOfflineWaveformEnabled = value => {
    offlineWaveformEnabled.value = value ? true : false
  }

  // --------------------------------------------------------
  // MISC
  // --------------------------------------------------------

  return {
    columnWidth,
    setColumnWidth,
    mouseClickEffectpixelRange,
    reverseScroll,
    subdivision,
    setSubdivision,
    hitPosY,
    SCROLLBAR_PADDING,
    SCROLLBAR_SIZE,
    setZoomY,
    setZoomX,
    setHitPosY,
    zoomX,
    zoomY,
    timeToPixel,
    pixelToTime,
    noteHeight,
    setSubdivisionColouringMagicNumber,
    setReverseScroll,
    getSubdivisionColour,
    subdivisionColouringMagicNumber,
    offlineWaveformEnabled,
    setOfflineWaveformEnabled,
  }
})